module.exports = __webpack_public_path__ + "static/media/logo_oikos.6893edb8.jpg";